<h1 class="app-title"><ng-content /></h1>
